import { render } from "./ConsolePageHeading.vue?vue&type=template&id=d71ce474&scoped=true"
import script from "./ConsolePageHeading.vue?vue&type=script&lang=js"
export * from "./ConsolePageHeading.vue?vue&type=script&lang=js"

import "./ConsolePageHeading.vue?vue&type=style&index=0&id=d71ce474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d71ce474"]])

export default __exports__